import campaigns from './campaigns';
import link from './link';
import redirect from './redirect';

export default {
  campaigns,
  redirect,
  link,
};
